import { useTranslation } from 'next-i18next'

import { SessionStatus as SessionStatusType } from '~/types/tutoring-api'
import { selectUserIsAdmin } from '~/auth/slices/auth.slice'
import { getSessionStatusColor } from '~/panels/utils/panels.utils'
import { useAppSelector } from '~/redux/hooks'

import SessionStatusSelect from './SessionStatusSelect'

export default function SessionStatus({
  displaySetSessionStatus,
  sessionId,
  setSessionStatus = () => undefined,
  status,
}: {
  displaySetSessionStatus: boolean | undefined
  sessionId: number
  setSessionStatus: ((sessionId: number, status: SessionStatusType) => void) | undefined
  status: SessionStatusType
}): React.ReactElement {
  const { t } = useTranslation(['generics', 'sessionStatus'])
  const userIsAdmin = useAppSelector(selectUserIsAdmin)

  if (displaySetSessionStatus && (userIsAdmin || status === SessionStatusType.PENDING)) {
    return (
      <div className="flex text-xxs">
        <span className="text-2.5 text-gray-link mr-1 leading-7">{t('generics:status')}:</span>
        <SessionStatusSelect
          onChange={(event) => setSessionStatus(sessionId, event.target.value as SessionStatusType)}
          status={status}
        />
      </div>
    )
  } else {
    return (
      <div className="flex py-1">
        <span className="text-2.5 text-gray-link mr-1">{t('generics:status')}:</span>
        <span className={`text-2.5 ${getSessionStatusColor(status)}`}>{t(`sessionStatus:${status}`)}</span>
      </div>
    )
  }
}
